import { Builder } from '@builder.io/sdk';
import dynamic from 'next/dynamic';

const UsefulGuides = dynamic(() => import('./UsefulGuides').then((m) => ({ default: m.UsefulGuides })));

const UsefulGuidesConfig = {
  name: 'UsefulGuides',
  friendlyName: 'Useful Guides',
  description: 'A grid of guide links. 2 columns on desktop, single column on mobile.',
  inputs: [
    {
      name: 'title',
      type: 'string',
      friendlyName: 'Heading',
      defaultValue: 'Useful Guides',
      helperText: 'Title displayed above the guide links.',
    },
    {
      name: 'guides',
      type: 'list',
      friendlyName: 'Guide Links',
      helperText: 'Add the guides you want to feature. Each needs a title and a URL.',
      subFields: [
        {
          name: 'label',
          type: 'string',
          required: true,
          friendlyName: 'Guide Title',
          helperText: 'Text shown on the link button (e.g. "How to secure your car: the definitive guide").',
        },
        {
          name: 'url',
          type: 'url',
          required: true,
          friendlyName: 'Link',
          helperText: 'URL this guide button links to.',
        },
      ],
    },
  ],
};

Builder.registerComponent(UsefulGuides, UsefulGuidesConfig);
